import React from 'react'
import styles from './FeedbackModal.module.css'

const StepIndicator = ({ totalSteps, currentStep }) => {
  return (
    <div className={styles.stepIndicator}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const isCompleted = index < currentStep
        const isCurrent = index === currentStep

        return (
          <React.Fragment key={index}>
            <div
              className={`${styles.stepCircle} ${
                isCompleted ? styles.completed : ''
              } ${isCurrent ? styles.current : ''}`}
            >
              {isCompleted ? '' : index + 1}
            </div>
            {index < totalSteps - 1 && (
              <div
                className={`${styles.stepConnector} ${
                  isCompleted ? styles.completed : ''
                }`}
              />
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default StepIndicator
